<div class="application-process-page container-fluid">
  <div class="row">
    <div class="col-12">
      <mat-tab-group
        [mat-stretch-tabs]="false"
        mat-align-tabs="start"
        [(selectedIndex)]="selectedIndex"
        (selectedTabChange)="onTabChange($event)">
        <mat-tab label="AML">
          <ng-template matTabContent>
            <aml-list />
          </ng-template>
        </mat-tab>
        <mat-tab label="KYB">
          <ng-template matTabContent>
            <kyb-run-list />
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
